// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/styles/app.scss
// module id = 1848
// module chunks = 0